import { Turnstile } from "@marsidev/react-turnstile";
import { useToast } from "@/contexts/ToastContext";

interface TurnstileWidgetProps {
  onTokenChange: (token?: string) => void;
}

export default function TurnstileWidget({
  onTokenChange,
}: TurnstileWidgetProps) {
  const { showToast } = useToast();

  // Get site key from environment variable
  const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;

  // Skip Turnstile in development if site key is not configured
  if (!siteKey) {
    console.warn(
      "NEXT_PUBLIC_TURNSTILE_SITE_KEY is not configured. CAPTCHA will not be displayed.",
    );
    // In development, provide a mock token if site key is missing
    if (process.env.NODE_ENV === "development") {
      onTokenChange("dev-mock-token");
      return null;
    }
    return null;
  }

  return (
    <div className="mt-4">
      <Turnstile
        siteKey={siteKey}
        onSuccess={(token) => {
          onTokenChange(token);
        }}
        onError={() => {
          showToast("CAPTCHA verification failed. Please try again.", "error");
          onTokenChange(undefined);
        }}
        onExpire={() => {
          showToast(
            "CAPTCHA verification expired. Please verify again.",
            "error",
          );
          onTokenChange(undefined);
        }}
        options={{
          theme: "light",
          size: "normal",
          appearance: "always",
          retry: "auto",
        }}
      />
    </div>
  );
}
